// extracted by mini-css-extract-plugin
module.exports = {"root":"HeFXfXWL","center":"+1nRab2d","button":"EVoG1BdU"};